// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaBaseFromJSON, TaBaseToJSON, TaParametersFromJSON, TaParametersToJSON, } from './';
export function TaModelFromJSON(json) {
    return {
        ...TaBaseFromJSON(json),
        ...TaParametersFromJSON(json),
    };
}
export function TaModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...TaBaseToJSON(value),
        ...TaParametersToJSON(value),
    };
}
